export const BUTTON_A = 'buttonA';
export const BUTTON_B = 'buttonB';
export const LED = 'led';
export const HTS221 = 'hts221';
export const LSM6DSL = 'lsm6dsl';
export const OLED = 'oled';


// WEBPACK FOOTER //
// ./src/constants/sensorName.js